import React from "react";
import ChooseImage from "./ChooseImage";
import Tool from "../../../../../Base/Tool";
import { faceIcon, linkedinIcon, telegaIcon } from "../../../../../Base/SVG";

export default function Info({
  updateForm,
  form,
  onChangeInput,
  fetchProfileData,
  isSignIn,
  isConnected,getAuth
}) {
  return (
    <div className="profile">
      <h5>
        <span></span> Profile information
      </h5>
      <ChooseImage
        imageData={form.avatar}
        updateForm={updateForm}
        fetchProfileData={fetchProfileData}
        isSignIn={isSignIn}
        isConnected={isConnected}
        getAuth={getAuth}
      />
      <div className="input__outer">
        <label htmlFor="">
          Display name
          <Tool text="Add Name." />
        </label>
        <div className="input">
          <input
            disabled={!isSignIn || !isConnected}
            type="text"
            placeholder="Enter Name"
            value={form.name}
            onChange={onChangeInput("name")}
          />
        </div>
      </div>
      <div className="input__outer">
        <label htmlFor="">
          Description{" "}
          <Tool text="Add Description." />
        </label>
        <div className="input">
          <textarea
            name=""
            id=""
            cols="30"
            rows="3"
            value={form.description}
            onChange={onChangeInput("description")}
            disabled={!isSignIn || !isConnected}
            placeholder="Enter description"

          ></textarea>
        </div>
      </div>
      <div className="profile__links">
        <div className="input__outer">
          <label htmlFor="">
            Facebook
            <Tool text="Add facebook link." />
          </label>
          <div className="input wS">
            <input
              disabled={!isSignIn || !isConnected}
              type="text"
              placeholder="www.facebook.com"
              value={form.facebookLink}
              onChange={onChangeInput("facebookLink")}
            />
            {faceIcon}
          </div>
        {!!form?.error?.facebook && <div className="errorMessage">Please enter valid address</div>}

        </div>
        <div className="input__outer">
          <label htmlFor="">
            Telegram
            <Tool text="Add telegram link." />
          </label>
          <div className="input wS">
            <input
              disabled={!isSignIn || !isConnected}
              type="text"
              placeholder="www.telegram.com"
              value={form.telegramLink}
              onChange={onChangeInput("telegramLink")}
            />
            {telegaIcon}
          </div>
        {!!form?.error?.telegram && <div className="errorMessage">Please enter valid address</div>}

        </div>
        <div className="input__outer">
          <label htmlFor="">
            LinkedIn
            <Tool text="Add linkedIn link." />
          </label>
          <div className="input wS">
            <input
              disabled={!isSignIn || !isConnected}
              type="text"
              placeholder="www.linkedin.com"
              value={form.linkedinLink}
              onChange={onChangeInput("linkedinLink")}
            />
            {linkedinIcon}
          </div>
        {!!form?.error?.linkedin && <div className="errorMessage">Please enter valid address</div>}

        </div>

      </div>
    </div>
  );
}
